// src/components/Documentation/data/errorCodes.js

export const errorCodes = [
  {
    code: '400',
    name: 'Bad Request',
    description: 'The request was invalid or missing required parameters'
  },
  {
    code: '401',
    name: 'Unauthorized',
    description: 'Invalid or missing API key'
  },
  {
    code: '429',
    name: 'Too Many Requests',
    description: 'Rate limit exceeded for your current plan'
  },
  {
    code: '500',
    name: 'Internal Server Error',
    description: 'An error occurred on our servers. Please try again later'
  }
];